<base-modal-component class="base-modal" [validation]="isValid()" (onConfirm)="save()">
    <fields-list-component [fields]="fields" name="ingredients_edit" [value]="ingredient"></fields-list-component>
</base-modal-component>
